<template>
   <div class="a4-endwise" id="print">
    <h2>中国传媒大学学生住宿信息确认表</h2>
    <table  class="table"  border="1">
      <tr>
        <td width=90>学号</td>
        <td  width=180 class="lefttd">
          {{ ruleForm.datas.student_No }}
        </td>
        <td width=90>姓名</td>
        <td width=180 class="lefttd">
          {{ ruleForm.datas.student_Name }}
        </td>     
        <td rowspan="6" colspan="2">
           <el-image
            :src="ruleForm.datas.student_Photo"
            class="avatar"
            style="
              margin: 0px auto;
              height: 150px;
              width: 120px;
            "
          ></el-image>
        </td>
      </tr>
      <tr>
        <td>拼音码</td>
        <td  class="lefttd">
          {{ ruleForm.datas.student_Name_Spell }}
        </td>
        <td>身份证号</td>
        <td  class="lefttd">
          {{ ruleForm.datas.student_IDnumber }}
        </td>
      </tr>
      <tr>
        <td>性别</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Sex }}
        </td>
        <td>生日</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Birthday }}
        </td>
      </tr>
      <tr>
          <td>学生类型</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Type }}
        </td>
         <td>手机号码</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Mobile }}
        </td>        
        </tr>
      <tr>
       
        <td>年级</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Grade }}
        </td>
        <td>学制</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Years }}
        </td>
      </tr>
      <tr>
        <td>民族</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_mz }}
        </td>
        <td>政治面貌</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Zzmm }}
        </td>
      </tr>
      <tr>
        <td>入学时间</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Entrance_DateStr }}
        </td>
        <td>毕业时间</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Leave_DateStr }}
        </td>
        <td width=80>邮箱</td>
        <td class="lefttd">{{ ruleForm.datas.student_Email }}</td>
      </tr>
      <tr>
        <td>院系</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Dept }}
        </td>
        <td>专业</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Specialty }}
        </td>
        <td>班级</td>
        <td class="lefttd">{{ ruleForm.datas.student_Class }}</td>
      </tr>
      <tr>
        <td>父/母姓名</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Home_Parents }}
        </td>        
         <td>家庭电话</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Home_Mobile }}
        </td>
        
        <td colspan="2" rowspan="5">
          <p>办理入住二维码：</p>
          <div id="qrcode"></div>
        </td>
      </tr>
      <tr>
        <td>家庭地址</td>
        <td colspan="3" class="lefttd">
          {{ ruleForm.datas.student_Home_address }}
        </td>        
      </tr>
      <tr>
        <td>籍贯</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_NativePlace }}
        </td>
        <td>邮编</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Home_Code }}
        </td>
        
      </tr>
       <tr>
        <td>公寓</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_BuildingName }}
        </td>
        <td>房间-床位</td>
        <td class="lefttd">
          {{ ruleForm.datas.student_Room }} - {{ ruleForm.datas.student_Cwname }}
        </td>  
              
      </tr>
      <tr>
        <td>备注</td>
        <td colspan="3" class="lefttd">
          {{ ruleForm.datas.student_Memo }}
        </td>        
      </tr>
    </table>
    <!-- <div><h3> {{ ruleForm.datas.student_Name }}的舍友</h3></div>
    <table class="table"  border="1">
      <tr v-for="(items) in ruleForm.Roomlist" :key="items.student_IdNumber">
        <td class="tdtitle" width=90>床位</td>
        <td>{{items.cw_Name}}</td>
        <td class="tdtitle" width=90>姓名</td>
        <td>{{items.student_Name}}</td>
        <td class="tdtitle" width=90>专业</td>
        <td>{{items.zsfp_TypeName}}</td>
      </tr>
      </table> -->
      
    <h5 style="text-align:right;">打印时间： {{new Date().getFullYear() +'-'+ (new Date().getMonth()+1) +'-'+ new Date().getDate()}}</h5>
  </div>
   <el-row>
        <el-col :span="8" :lg="8"></el-col>
        <el-col :span="8" :lg="8">
        <el-button class="el-button-cuc"  @click="doPrint(ruleForm.datas.student_IDnumber)"
          >打印住宿确认表</el-button></el-col>
         <el-col :span="8" :lg="8"></el-col>
      </el-row>
</template>

<script>
import { qrcanvas } from "qrcanvas";
import { getStudent } from "../http/api.ts";
import { getRoomStudent } from "../http/api.ts";
import { reactive } from "vue";

export default {
  
  setup() {
    let ruleForm = reactive({
      datas: [],
      Roomlist:[]
    });
    let dataFun = async () => {
      await getStudent().then((res) => {
        ruleForm.datas = res.datas;
      });
      await getRoomStudent(ruleForm.datas.student_Room_Serial,ruleForm.datas.student_Grade).then((res) => {
        ruleForm.Roomlist = res.datas;
      });
    };
    dataFun();   
    let doC=async()=>{
        let canvas = qrcanvas({
            data:"http://"+ window.location.host+ "/studentroom?idnumber="+ruleForm.datas.id,
            size: 128,
            colorDark: "red",
          });
          document.getElementById("qrcode").innerHTML='';
          document.getElementById("qrcode").appendChild(canvas);
    }
    setTimeout(function(){
      doC()
      }
      ,500);
    return {
      ruleForm,
    };
  },
  methods: {
    doPrint(ids){ 
          const jubuData = document.querySelector('#print').innerHTML;
          window.document.body.innerHTML = jubuData;
          this.doCanvas(ids);
          window.print();
          // 重新给页面内容赋值；
          window.location.reload();
    }
    ,doCanvas(ids){
      console.info(ids);
        let canvas = qrcanvas({
            data:"http://"+ window.location.host+ "/studentroom?id="+ids,
            size: 128,
            colorDark: "red",
          });
          document.getElementById("qrcode").innerHTML='';
          document.getElementById("qrcode").appendChild(canvas);
    }
   }
  
};
</script>
<style scoped>

.table {
  width: 800px;
	border-spacing: 0;			
  text-align: center;
	border-collapse: unset;
	border-top: #000 1px solid;
	border-right: #000 1px solid; 
} 
.table td {
	border-left: #000 1px solid;
	border-bottom: #000 1px solid;
}
.table tr{height: 40px;}
.lefttd{
  text-align: left;
}
.tdtitle{
  font-weight: bold;
}
.a4-endwise {
  margin: 0 auto;
  width: 800px;
  height: auto;
  overflow: hidden;
  padding: 0;
  word-break: break-all;
}

.el-button-cuc,.el-button-cuc:hover,.el-button-cuc:focus{
  float: left;
	background-image:none;
	background-color:#059490;
	width: calc(100% - 40px);
	line-height: 1;
	padding:10px 0;
	cursor: pointer;
	border:1px solid #04726f;
	font-family:"Microsoft YaHei";
	font-size:16px;
	height:50px;
	line-height:30px;
	border-radius:6px;
	margin: 8px 0 0 21px;
	color:#fff;
	text-align:center;
	position:relative;
	box-sizing: border-box;
}
</style>